<template>
  <div class="top">
    <during-vote v-if="termType === 1" />
    <ended-vote v-if="termType === 2" />
    <result-vote v-if="termType === 3" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DuringVote from '@components/top/during-vote.vue'
import EndedVote from '@components/top/ended-vote.vue'
import ResultVote from '@components/top/result-vote.vue'
export default {
  name: 'top',
  components: {
    DuringVote,
    EndedVote,
    ResultVote,
  },
  computed: {
    ...mapGetters('menu', ['termType']),
  }
}
</script>

<style lang="scss" scoped></style>
